import { ChakraProvider, ChakraProviderProps, extendTheme } from '@chakra-ui/react'
import { useMemo } from 'react'
import { theme as baseTheme } from '../theme'

export function DaveProvider({ theme, ...props }: ChakraProviderProps) {
  const appTheme = useMemo(() => extendTheme(theme ?? {}, baseTheme), [theme])

  return <ChakraProvider {...props} theme={appTheme} />
}
